import * as XLSX from 'xlsx';

const CLUSTER_EXPORT_COLUMNS = [
  'Cluster',
  'Mot-clé',
  'Volume',
  'Similarité',
  'Position',
  'Trafic estimé',
  'URL actuelle',
  'URL à positionner'
];

export const exportToCSV = (data, filename, columnOrder = null) => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  const headers = columnOrder || Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row =>
      headers.map(header => {
        const value = row[header];
        if (value === null || value === undefined) return '';
        const stringValue = String(value);
        return stringValue.includes(',') ? `"${stringValue}"` : stringValue;
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(url);
};

export const exportToExcel = (sheets, filename, columnOrder = null) => {
  if (!Array.isArray(sheets) || sheets.length === 0) {
    console.warn('Aucune feuille à exporter');
    return false;
  }

  try {
    const workbook = XLSX.utils.book_new();
    let hasDataSheet = false;

    sheets.forEach(({ name, data }) => {
      if (data && data.length > 0) {
        const orderedData = columnOrder 
          ? data.map(row => {
              const orderedRow = {};
              columnOrder.forEach(col => {
                if (Object.prototype.hasOwnProperty.call(row, col)) {
                  orderedRow[col] = row[col];
                }
              });
              Object.keys(row).forEach(key => {
                if (!Object.prototype.hasOwnProperty.call(orderedRow, key)) {
                  orderedRow[key] = row[key];
                }
              });
              return orderedRow;
            })
          : data;
        const worksheet = XLSX.utils.json_to_sheet(orderedData);
        XLSX.utils.book_append_sheet(workbook, worksheet, name);
        hasDataSheet = true;
      }
    });

    if (!hasDataSheet) {
      console.warn('Aucune donnée dans les feuilles à exporter');
      return false;
    }

    XLSX.writeFile(workbook, `${filename}.xlsx`);
    return true;
  } catch (error) {
    console.error('Erreur lors de l\'export Excel:', error);
    return false;
  }
};

export { CLUSTER_EXPORT_COLUMNS };

export const prepareSimilaritiesForExport = (similarities) => {
  return similarities.map(sim => ({
    'Mot-clé 1': sim.keyword1 || '',
    'Volume 1': sim.volume1 || 0,
    'Mot-clé 2': sim.keyword2 || '',
    'Volume 2': sim.volume2 || 0,
    'Score de similarité (%)': Math.round(sim.similarityScore) || 0
  }));
};
